import Vue from 'vue';
import Router from 'vue-router';
import Title from '@/components/views/Title';
import GameOver from '@/components/views/GameOver';
import Game from '@/components/views/Game';
import Scene from '@/components/views/Scene';
import WelcomeEmail from '@/components/emails/WelcomeEmail';
import RewardEmail from '@/components/emails/RewardEmail';
import SpecialEmail from '@/components/emails/SpecialEmail';
import GameOverEmail from '@/components/emails/GameOverEmail';


Vue.use(Router);

export default new Router({
	mode: "abstract",
	routes: [
		{
			path: '/',
			name: 'Title',
			component: Title,
		},
		{
			path: '/game_over',
			name: 'GameOver',
			component: GameOver,
		},
		{
			path: '/game',
			name: 'Game',
			component: Game,
			children: [
				{
					path: 'welcome',
					name: 'Welcome',
					component: WelcomeEmail,
				},
				{
					path: 'scene/:level/:scene',
					name: 'Scene',
					component: Scene,
				},
				{
					path: 'reward/:level/',
					name: 'Reward',
					component: RewardEmail,
				},
				{
					path: 'special/:id/',
					name: 'Special',
					component: SpecialEmail,
				},
				{
					path: 'gameoveremail',
					name: 'GameOverEmail',
					component: GameOverEmail,
				},
			],
		},
	],
});



// WEBPACK FOOTER //
// ./src/router/index.js